import { render, staticRenderFns } from "./imageEdit.vue?vue&type=template&id=4be3f048&"
import script from "./imageEdit.vue?vue&type=script&lang=js&"
export * from "./imageEdit.vue?vue&type=script&lang=js&"
import style0 from "./imageEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports